module.exports = __webpack_public_path__ + "img/1.397cae1f.png";